module.exports = __webpack_public_path__ + "img/onDispatch_banner.a6a4bdb8.png";